import { Button, Flex, Space, Spacing, Text } from '@billy/design-system'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceEditorForm } from '../../../../../../../../../contexts/invoiceEditorFormContext'
import { useInvoiceEditorBaseCurrency } from '../../../../../../../../../hooks/useInvoiceEditorBaseCurrency'
import { useUpdateDependentCurrencies } from '../../../../../hooks/useUpdateDependentCurrencies'
import { CurrencyInput } from '../../../../CurrencyInput'

interface ExchangeRateInputProps {
  onSave: () => void
}

export const ExchangeRate = ({ onSave }: ExchangeRateInputProps) => {
  const { t } = useTranslation()
  const { handleExchangeRateChange } = useUpdateDependentCurrencies()
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { baseCurrency } = useInvoiceEditorBaseCurrency()

  const { watch } = invoiceEditorForm
  const exchangeRate = watch('exchangeRate')

  const [inputValue, setInputValue] = useState(exchangeRate)

  const handleExchangeRateValueChange = useCallback((value: number) => {
    setInputValue(value)
  }, [])

  const handleSaveButtonClick = useCallback(() => {
    if (inputValue) {
      const currentInputValue = inputValue > 0 ? inputValue : exchangeRate
      handleExchangeRateChange(currentInputValue)
    }

    onSave()
  }, [exchangeRate, handleExchangeRateChange, inputValue, onSave])

  useEffect(() => {
    setInputValue(exchangeRate)
  }, [exchangeRate])

  return (
    <>
      <Text colorVariant="secondary" variant="bodySM">
        {t('external_invoices.editor.form.field.invoice_lines.exchange_rate.input_info')}
      </Text>
      <Space size="s8" />
      <Flex alignItems="center" gap={Spacing.S8}>
        <Text colorVariant="secondary" nowrap variant="bodySM">
          1 {baseCurrency} =
        </Text>
        <CurrencyInput min={0} onChange={handleExchangeRateValueChange} value={inputValue} />
        <Button onClick={handleSaveButtonClick} variant="outlined">
          {t('save')}
        </Button>
      </Flex>
    </>
  )
}
